module.exports = __webpack_public_path__ + "img/20230515162536_60839.10a61e60.jpg";